<template>
    <div class="product-container">
        <Header style="position: relative" :theme="$store.state.theme == 'light' ? 'dark' : 'light'"/>
        <Breadcrumbs
            :path="[
                {name: 'Главная', url: '/'},
                {name: 'Каталог', url: '/catalog'},
                {name: category_ru.charAt(0).toUpperCase() + category_ru.slice(1).replace('_' , ' '), url: `/catalog/${category.charAt(0).toLowerCase() + category.slice(1)}`},
                {name: title, url: '/'},
            ]"
        />
        <div>
            <SkeletonHeaderProduct v-if="title === ''"/>
            <HeaderProduct v-else :image="imageBase64" :title="title"/>
            <SkeletonParser v-if="header == ''"/>
            <Parser v-else :header="header"/>

            <DocumentationProductPage
                                    :title="$store.state.lang === 'ru-RU' ? 'Документация' : 'Documentation'"
                                    :names="arrayHeaderImageNamesDocument.uploadedNamesDocument"
                                    :id="productID"
                                    :arrayElement="arrayHeaderImageNamesDocument.headerImageBase64Document"

            />

            <CardCarousel
                    :title="$store.state.lang == 'ru-RU' ? 'РЕКОМЕНДУЕМОЕ ИЗ ТОЙ ЖЕ КАТЕГОРИИ' : 'RECOMMENDED FROM THE SAME CATEGORY'"
                    :cards="recommendedCard.filter(card => card.id != productID)"
                    :link="`/product/`"
                    :category_type="category"
                    :description="''"
                    v-if="recommendedCard.length > 1"
            />

        </div>
        <Footer/>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import HeaderProduct from "@/components/Product/HeaderProduct.vue";
import DescriptionProduct from "@/components/Product/DescriptionProduct.vue";
import SpecificationsProduct from "@/components/Product/SpecificationsProduct.vue";
import RecommendedProduct from "@/components/Product/RecommendedProduct.vue";
import {HTTP} from "@/plugins/http-common";
import CardCarousel from "@/components/CardCarousel.vue";
import Parser from "@/components/Parser/Parser.vue";
import SkeletonHeaderProduct from "@/components/Sceletons/SkeletonHeaderProduct.vue";
import SkeletonParser from "@/components/Sceletons/SkeletonParser.vue";
import {useHead} from "@vueuse/head"
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue"
import DocumentationProductPage from "@/components/DocumentationProductPage.vue";

export default {
    name: "Product",
    components: {
        DocumentationProductPage,
        SkeletonParser,
        SkeletonHeaderProduct,
        Parser,
        RecommendedProduct,
        SpecificationsProduct,
        DescriptionProduct,
        HeaderProduct,
        Footer,
        Header,
        CardCarousel,
        Breadcrumbs
    },
    data() {
        return {
            // Header Product
            imageBase64: [],
            header: [],
            title: "",
            titleEN: "",
            characteristicRU: "",
            category: '',
            category_ru: '',
            characteristicEN: "",

            // Description Product
            titleDescription: '',

            description: '',
            keywords: '',

            titleDistinctiveFeatures: '',
            ArrayList: [],

            titleSystemComposition: '',
            SystemComposition: "",

            titleScopeOfApplication: '',
            ScopeOfApplication: '',


            arrayHeaderImageNamesDocument: {
              headerImageBase64Document: [],
              uploadedNamesDocument: []
            },

            //
            recommendedCard: [],

            errorStatus: false
        }
    },
    props: {
        productID: {
            default: '1'
        },
    },

    created() {
        try {
          HTTP.get(`/catalog/get_catalog_by_id/${this.productID}${this.$store.state.lang === 'ru-RU' ? 'ru' : 'eng'}`).then(response => {
            let imagePaths = JSON.parse(response.data?.image).image;

            this.imageBase64 = [];

            const imagePromises = imagePaths.map((imagePath, index) => {
              const formData = new FormData();
              formData.append('image', imagePath);

              return HTTP.post('/get_image/download_image', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
                responseType: 'blob'
              }).then(postResponse => {
                const url = URL.createObjectURL(postResponse.data);
                return { url, index };
              });
            });

            Promise.all(imagePromises).then(results => {
              results.sort((a, b) => a.index - b.index);

              this.imageBase64 = results.map(result => result.url);
            });

            for (let i in response.data.body) {
              this.header[i] = response.data.body[i];
            }

            this.title = response.data.title;
            this.category = JSON.parse(response.data.category).category_eng;
            this.category_ru = JSON.parse(response.data.category).category_ru


            this.$watch(
                () => this.productID,
                async () => {
                  this.title = '';
                  this.imageBase64 = [];
                  this.header = [];
                  this.category = '';
                  this.category_ru = '';

                  try {
                    const lang = this.$store.state.lang === 'ru-RU' ? 'ru' : 'eng';
                    const [getResponse] = await Promise.all([
                      HTTP.get(`/catalog/get_catalog_by_id/${this.productID}${lang}`)
                    ]);

                    const responseData = getResponse.data;

                    for (let i in responseData.body) {
                      this.header[i] = responseData.body[i];
                    }

                    imagePaths = JSON.parse(responseData.image).image;
                    this.imageBase64 = [];

                    const imagePromises = imagePaths.map((imagePath, index) => {
                      const formData = new FormData();
                      formData.append('image', imagePath);

                      return HTTP.post('/get_image/download_image', formData, {
                        headers: {
                          'Content-Type': 'multipart/form-data',
                        },
                        responseType: 'blob'
                      }).then(postResponse => {
                        const url = URL.createObjectURL(postResponse.data);
                        return { url, index };
                      });
                    });

                    const results = await Promise.all(imagePromises);

                    results.sort((a, b) => a.index - b.index);

                    this.imageBase64 = results.map(result => result.url);

                    this.title = responseData.title;
                    this.category = JSON.parse(responseData.category).category_eng;
                    this.category_ru = JSON.parse(response.data.category).category_ru
                    console.log(response.data);
                    
                  } catch (error) {
                    console.error('Ошибка при выполнении запросов:', error);
                    window.location.href = '/404';
                  }

                  document.getElementsByClassName('product-container')[0].scrollTop = 0;
                }
            );
            
            const categoryType = JSON.parse(response.data?.category_transcription).category_ru.replaceAll(' ', '_');
            const cardName = response.data?.title_transcription.replaceAll(' ', '_');
            useHead({
              title: response.data?.title,
              meta: [
                {
                  name: `description`,
                  content: JSON.parse(response.data?.description)?.description
                },
                {
                  name: `keywords`,
                  content: JSON.parse(response.data?.keywords)?.keywords.join()
                },
                { 
                  property: 'og:title', 
                  content: response.data.title
                },
                { 
                  property: 'og:description', 
                  content: JSON.parse(response.data?.description)?.description
                },
                { 
                  property: 'og:image', 
                  content: JSON.parse(response.data?.image)?.image[0] 
                }, 
                { 
                  property: 'og:url', 
                  content: `${window.location.origin}/catalog/${categoryType}/${cardName}?id=${this.productID}`
                },
                { 
                  property: 'og:type', 
                  content: 'product' 
                }
              ]
            });

            try {
              HTTP.get(`/catalog/get_by_category${this.category}`)
                  .then(response => {
                    Promise.all(
                        response.data.map(item => {
                          let parsedImage = JSON.parse(item.image).image[0];

                          const formData = new FormData();
                          formData.append('image', parsedImage);

                          return HTTP.post('/get_image/download_image', formData, {
                            headers: {
                              'Content-Type': 'multipart/form-data',
                            },
                            responseType: 'blob'
                          }).then(postResponse => {
                            const url = URL.createObjectURL(postResponse.data);
                            
                            return {
                              id: item.id,
                              title: item.title,
                              category: item.category,
                              title_transcription: item.title_transcription,
                              image: url
                            };
                          });
                        })
                    )
                        .then(results => {
                          this.recommendedCard = results;
                        })
                        .catch(err => {
                          console.error(err);
                        });
                  })
                  .catch(err => {
                    console.error(err);
                  });

            } catch (e) {
              console.error(e);
            }

            try {
              HTTP.get(`/catalog/get_pdf_by_id/${this.productID}`).then(response => {
                this.arrayHeaderImageNamesDocument.headerImageBase64Document = JSON.parse(JSON.parse(response.data.pdf).pdf);
              }).catch(err => {
                this.errorStatus = true;
              });
            } catch (e) {
              console.error(e);
            }

            try {
              HTTP.get(`/catalog/get_pdf_title_by_id/${this.productID}`).then(response => {
                this.arrayHeaderImageNamesDocument.uploadedNamesDocument = response.data.title_ru;
              }).catch(err => {
                this.errorStatus = true;
              });
            } catch (e) {
              console.error(e);
            }

          }).catch(err => {
            console.error(err);
            window.location.href = '/404';

          });





        } catch (e) {

        }


    },

    // inheritAttrs: false,


}
</script>

<style scoped>
.product-container {
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100vh;
}

</style>